import React from 'react';
import { TopHeaderBar } from '../components/TopHeaderBar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { PricingSection } from '../components/PricingSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen" data-id="element-155">
      <TopHeaderBar data-id="element-156" />

      <main className="pb-8" data-id="element-157">
        <HeroSection data-id="element-158" />
        <ProblemSection data-id="element-159" />
        <MethodSection data-id="element-160" />
        <PricingSection data-id="element-161" />
        <BonusSection data-id="element-162" />
        <TestimonialsSection data-id="element-163" />
        <GuaranteeSection data-id="element-164" />
        <FAQSection data-id="element-165" />
        <FinalCTASection data-id="element-166" />
      </main>

      <Footer data-id="element-167" />
    </div>;
}
export default LandingPage;